import React from "react";
import { BlogAuthor } from "@/.storyblok/types/319751/storyblok-components";
import { storyblokEditable, SbBlokData } from "@storyblok/react";
import Image from "next/image";

interface AuthorBioProps {
  blok?: BlogAuthor & SbBlokData;
}

const BlogAuthorComponent: React.FC<AuthorBioProps> = ({ blok }) => {
  if (!blok) return null;

  const { name, bio, title, image, linkedin } = blok;

  return (
    <div
      {...storyblokEditable(blok)}
      className="bg-oxford-blue text-white py-4"
      id="author-bio"
    >
      <div className="container">
        <div className="two-thirds-centered">
          <div className="row">
            {/* Author's Image */}
            <div className="col-24 col-md-8 text-center mb-4 mb-md-0">
              {image?.filename && (
                <Image
                  alt={`${name || "Author"} Headshot`}
                  className="blog-author-img rounded-circle"
                  src={image.filename}
                  width="180"
                  height="180"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  quality={75}
                />
              )}
            </div>

            {/* Author Meta Details */}
            <div className="col-24 col-md-16 blog-author-meta">
              <h3 className="text-white text-uppercase blog-author-heading mb-2">
                Meet the author
              </h3>
              <h4 className="h3">
                {name}{" "}
                {title && <span className="blog-author-title">{title}</span>}
              </h4>
              {bio && <p>{bio}</p>}

              {/* Links Section */}
              <ul className="list-unstyled mb-0">
                {/* Other Blogs Link */}
                <li className="blog-other-blogs">
                  <i
                    className="fas fa-fw fa-file me-2 text-secondary"
                    aria-hidden="true"
                  ></i>
                  <a
                    className="text-secondary"
                    href={`/articles/author/${name?.toLowerCase()?.replace(/\s+/g, "_")}`}
                  >
                    See other blogs by {name}
                  </a>
                </li>
                {/* LinkedIn Link */}
                {linkedin?.cached_url && (
                  <li>
                    <i
                      className="fab fa-fw fa-linkedin me-2 text-secondary"
                      aria-hidden="true"
                    ></i>
                    <a
                      className="text-secondary"
                      href={linkedin.cached_url}
                      target="_blank"
                      rel="noopener"
                    >
                      Follow {name} on LinkedIn
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogAuthorComponent;